const conditions: Mapping[] = [
  {
    label: '震度4以上',
    value: 0,
  },
  {
    label: '震度5弱以上',
    value: 1,
  },
  {
    label: '震度5強以上',
    value: 2,
  },
  {
    label: '震度6弱以上',
    value: 3,
  },
  {
    label: '震度6強以上',
    value: 4,
  },
  {
    label: '震度7以上',
    value: 5,
  },
];

export default conditions;
